export const loginRoute = '/login';

export const communicatorRoute = '/communicator';

export const offersRoute = '/offers/:offerKey';

// export const checkoutRoute = '/checkout';

const contactRouteBase = '/contacts';

export const contactRoutes = {
    groups: `${contactRouteBase}/:listId`,
    setGroups: (listId: number) => `${contactRouteBase}/${listId}`,
    details: `${contactRouteBase}/:contactId/details`,
    setDetails: (contactId: number) => `${contactRouteBase}/${contactId}/details`,
};

const settingsRouteBase = '/settings';
const aiRouteBase = '/ai';
const usersRouteBase = '/users';
const campaignRouteBase = '/campaigns';

const helpRouteBase = '/help';
const categoryRouteBase = '/category';
const articleRouteBase = '/article';

export const calendarRouteBase = '/calendar';

export const activityReportRoute = '/activityReport';

export const settingsRoutes = {
    new: `${settingsRouteBase}/new`,
    users: `${settingsRouteBase}${usersRouteBase}`,
    createEditUser: `${settingsRouteBase}${usersRouteBase}/:userName`,
    setCreateEditUser: (userName?: string) =>
        `${settingsRouteBase}${usersRouteBase}/${userName ? userName : 'new'}`,
    testing: `${settingsRouteBase}/testing`,
    changePassword: `${settingsRouteBase}/changePassword`,
    customFields: `${settingsRouteBase}/customFields`,
    customViews: `${settingsRouteBase}/customViews`,
    importExport: `${settingsRouteBase}/importexport`,
    general: `${settingsRouteBase}/general`,
    notification: `${settingsRouteBase}/notification`,
    userEmail: `${settingsRouteBase}/useremail`,
    contactStatus: `${settingsRouteBase}/contactStatus`,
    calendar: `${settingsRouteBase}/calendar`,
    google: `${settingsRouteBase}/google`,
    ai: `${settingsRouteBase}${aiRouteBase}`,
    aiPrompts: `${settingsRouteBase}${aiRouteBase}/prompts`,
    aiCreateEditPrompt: `${settingsRouteBase}${aiRouteBase}/prompts/:promptId`,
    setCreateEditPrompt: (promptId?: number) =>
        `${settingsRouteBase}${aiRouteBase}/prompts/${promptId ? promptId : 'new'}`,
    aiSmartReply: `${settingsRouteBase}${aiRouteBase}/smartReply`,
    aiBuildSmartReplyPlan: `${settingsRouteBase}${aiRouteBase}/smartReply/:planId`,
    setBuildSmartReplyPlan: (planId?: number) =>
        `${settingsRouteBase}${aiRouteBase}/smartReply/${planId ? planId : 'new'}`,
    aiContactPlanItemEvent: `${settingsRouteBase}${aiRouteBase}/smartReplyEvents/:contactPlanItemId`,
    setAiContactPlanItemEvent: (contactPlanItemId?: number) =>
        `${settingsRouteBase}${aiRouteBase}/smartReplyEvents/${contactPlanItemId}`,
    integrations: `${settingsRouteBase}/integrations`,
    phoneSettings: `${settingsRouteBase}/phoneSettings`,
    changeSicNumber: `${settingsRouteBase}/changeSicNumber`,
    packageUsage: `${settingsRouteBase}/packageUsage`,
};

export const campaignRoutes = {
    webPush: `${campaignRouteBase}/webpush`,
};

export const noSicRoute = '/noPackage';

export const migrateFromEngage = '/migrateFromEngage';

export const orderRoute = '/orders';

export const orderRoutes = {
    success: `${orderRoute}/success/:sessionId`,
    cancelled: `${orderRoute}/cancelled/:sessionId`,
};

export const gettingStartedRoute = '/gettingStarted';

export const supportRoute = '/support';

export const helpRoutes = {
    helpHome: `${helpRouteBase}`,
    category: `${helpRouteBase}${categoryRouteBase}/:categoryId`,
    setCategory: (categoryId: number) => `${helpRouteBase}${categoryRouteBase}/${categoryId}`,
    article: `${helpRouteBase}${articleRouteBase}/:articleId`,
    setArticle: (articleId: number) => `${helpRouteBase}${articleRouteBase}/${articleId}`,
};
